/** Advance the release-to-reverse latch after an authoritative tick. */
export function advanceInterlockState(state, transition) {
    if (transition.driveDirection !== 0) {
        return {
            stoppedFromDirection: 0,
            reverseReleaseReady: true,
            forwardReleaseReady: true,
        };
    }
    let stoppedFromDirection = state.stoppedFromDirection;
    let reverseReleaseReady = state.reverseReleaseReady;
    let forwardReleaseReady = state.forwardReleaseReady;
    if (transition.previousDriveDirection !== 0) {
        stoppedFromDirection = transition.previousDriveDirection;
        reverseReleaseReady =
            transition.previousDriveDirection !== 1 || !transition.input.brake;
        forwardReleaseReady =
            transition.previousDriveDirection !== -1 || !transition.input.accelerate;
    }
    if (stoppedFromDirection === 1 && !transition.input.brake) {
        reverseReleaseReady = true;
    }
    if (stoppedFromDirection === -1 && !transition.input.accelerate) {
        forwardReleaseReady = true;
    }
    return {
        stoppedFromDirection,
        reverseReleaseReady,
        forwardReleaseReady,
    };
}
